<template>

  <v-container class="nx-showroom-page">
    <v-layout>
      <v-flex class="xs12 md8 my-4">
        <h2>nx-form-color-picker</h2>
        <nx-color-picker
          label="Seleccionar color"
          :required="true"
          value="ff3456"
        ></nx-color-picker>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="xs12 md8 my-4">
        <h2>nx-form-html-editor</h2>
        <nx-quill-editor
          value="asdf"
          type="advanced"
          :options="{}"
          hint="asdf"
          :disabled="false"
        ></nx-quill-editor>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="xs12 md8 my-4">
        <h2>nx-navigation-url</h2>
        <nx-navigation-url
          v-model="url"
        ></nx-navigation-url>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="xs12 md8 my-4">
        <h2>nx-seo-site-editor</h2>
        <nx-seo-site-editor
          value="value"
          @input="onInput">
        </nx-seo-site-editor>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="xs2">
        <h2>nx-image landscape</h2>
        <nx-image
            src="https://www.red-travel.com/imcom/photogallery/1280x960/red_travel_579.jpg"
            width="160"
            height="90"
        >
        </nx-image>
      </v-flex>
      <v-flex class="xs2">
        <h2>nx-image square</h2>
        <nx-image
            src="https://farm6.staticflickr.com/5636/22051627688_b7ce9d7cf2_b.jpg"
            width="160"
            height="90"
        >
        </nx-image>
      </v-flex>
      <v-flex class="xs2">
        <h2>nx-image portrait</h2>
        <nx-image
            src="https://i.pinimg.com/736x/b3/aa/c4/b3aac48fcdeb2e38c4d4689e9812cb4f--la-ferrari-ferrari-laferrari.jpg"
            width="160"
            height="90"
        >
        </nx-image>
      </v-flex>
      <v-flex class="xs2">
        <h2>nx-image broken</h2>
        <nx-image
            src="xxx"
            width="160"
            height="90">
        </nx-image>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs12 md8 my-4">
        <h2>nx-navigation-editor</h2>
        <nx-navigation-editor v-model="navigation" type="main-menu"></nx-navigation-editor>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs12 md8">
        <h2>nx-authorization-permision-editor</h2>
        <nx-authorization-permissions-editor
            v-model="permissions"
        ></nx-authorization-permissions-editor>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs12 md8">
        <h2>nx-board-selector</h2>
        <pre>{{ boardId }}</pre>
        <nx-board-selector
            v-model="boardId"
        ></nx-board-selector>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs12 md8">
        <h2>nx-site-selector</h2>
        <nx-site-selector
            v-model="siteIds"
            :limit="1"
        ></nx-site-selector>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs12 md8">
        <h2>nx-clipping-selector</h2>
        <nx-clipping-selector
            label="Imagen"
            :aspectRatios="clippingSelector.aspectRatios"
            :value="clippingSelector.value"
            @input="onInput('clippingSelector', $event)"
        ></nx-clipping-selector>
      </v-flex>
    </v-layout>

    <div style="width: 250px;">

      <h2>nx-clipping-selector</h2>
      <nx-clipping-selector
          label="Imagen"
          :aspectRatios="clippingSelector.aspectRatios"
          :value="clippingSelector.value"
          @input="onInput('clippingSelector', $event)"
      ></nx-clipping-selector>

    </div>

    <v-layout>
      <v-flex class="xs12 md8">
        <h2>nx-file-selector</h2>
        <nx-file-selector
            label="Subir un archivo"
            v-model="file"
        ></nx-file-selector>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="xs12 md6">
        <h2>nx-file-image-selector</h2>
        <nx-file-image-selector
            label="Avatar del staff"
            v-model="fileImage"
        ></nx-file-image-selector>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="xs6">
        <h2>date-picker</h2>
        <nx-date-picker
            v-model="date"
            :autoclose="true"
            label="Fecha"></nx-date-picker>
        <nx-date-time-picker
            v-model="time"
            :autoclose="false"
            label="Fecha"
            timeLabel="Hora"></nx-date-time-picker>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <h2>URL relation editor 2</h2>
        <nx-url-relation-editor
            title="Editor de Url"
            v-model="url"
            first-suggested-path="/hola/que/tal/"
        ></nx-url-relation-editor>

      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <h2>Filters</h2>
        <nx-filters
            :filters="filters"
            v-model="filtersmodel"
        ></nx-filters>
        <pre>{{ filtersmodel }}</pre>
      </v-flex>
    </v-layout>

    <div style="height: 200px;"></div>

    <nx-form>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationMoreInfo"
          label="Relación relationMoreInfo"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationMultimedia"
          label="Relación relationMultimedia"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationPhotogallery"
          label="Relación relationPhotogallery"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationImage"
          label="Relación relationImage"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationTwitter"
          label="Relación relationTwitter"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationOg"
          label="Relación relationOg"
          :card-params="cardParams"
      ></nx-relation>
      <nx-relation
          v-model="relaiton"
          :limit="4"
          name="relationContent"
          label="Relación relationContent"
          :card-params="cardParams"
      ></nx-relation>
    </nx-form>

  </v-container>
</template>

<script>
import NxNavigationUrl from '@/modules/navigation/components/NavigationUrl';
import QuillEditor from '@/components/texteditor/QuillEditor';
import SEOSiteEditor from '@/modules/seo/editor/SiteEditor';
import NxColorPicker from '@/components/color/ColorPicker';

import NxForm from '@/modules/form/Form';
import BasePage from '@/pages/BasePage';
import NxImage from '@/components/media/Image';
import NxDatePicker from '@/components/date/DatePicker';
import NxDateTimePicker from '@/components/date/DateTimePicker';
import NxClippingSelector from '@/modules/clipping/Selector';
import NxFileImageSelector from '@/modules/file/FileImageSelector';
import NxFileSelector from '@/modules/file/FileSelector';
import NxAuthorizationPermissionsEditor from '@/modules/authorization/PermissionsEditor';
import NxBoardSelector from '@/modules/board/selector/Selector';
import NxNavigationEditor from '@/modules/navigation/NavigationEditor';
import NxSiteSelector from '@/modules/site/Selector';
import NxUrlRelationEditor from '@/modules/url/UrlFormSelector';
import NxFilters from '../../../components/filters/Filters';

export default {
  name: 'nx-showroom',
  extends: BasePage,
  components: {
    NxColorPicker,
    NxNavigationUrl,
    [QuillEditor.name]: QuillEditor,
    [SEOSiteEditor.name]: SEOSiteEditor,
    NxFilters,
    NxForm,
    NxFileSelector,
    NxUrlRelationEditor,
    NxSiteSelector,
    NxNavigationEditor,
    NxBoardSelector,
    NxAuthorizationPermissionsEditor,
    NxClippingSelector,
    NxImage,
    NxDatePicker,
    NxDateTimePicker,
    NxFileImageSelector,
  },
  data() {
    return {
      relaiton: [],
      cardParams: {
        aspectRatios: ['4-3-aspect-ratio', '16-9-aspect-ratio'],
        types: ['article', 'video', 'videoembed'],
      },
      filtersmodel: {},
      filters: [
        {
          filter: 'state',
          component: 'NxFilterUniqueCheckbox',
          params: {
            options: [
              'published',
              'not-published',
            ],
          },
        },
        {
          filter: 'creationDate',
          component: 'NxFilterDates',
          params: [],
        },
        {
          filter: 'publishedDate',
          component: 'NxFilterDates',
          params: [],
        },
        {
          filter: 'sourceCode',
          component: 'NxFilterCheckboxes',
          params: {
            options: [
              'bCube',
              'legacy',
              'feed',
            ],
          },
        },
      ],
      url: {
        path: '/Robots/',
        siteId: 1,
        type: 'boardUrl',
        id: 1000019,
        boardId: 1000002,
      },
      pagination: {
        sortBy: 'name',
      },
      activeTab: null,
      date: null,
      time: null,
      file: null,
      fileImage: null,
      clippingSelector: {
        value: null,
        aspectRatios: ['1-1-aspect-ratio', '4-3-aspect-ratio', '3-4-aspect-ratio', '16-9-aspect-ratio', '9-16-aspect-ratio'],
      },
      boardId: null,
      siteIds: [],
      navigation: [
        {
          id: 10001,
          name: 'Home',
          link: {
            url: 'http://bbnx.bitban.com',
            type: 'link',
          },
          children: [],
        },
        {
          id: 10002,
          name: 'Deportes',
          link: {
            url: 'http://bbnx.int.bitban.com/deportes',
            target: '_blank',
            type: 'manual',
          },
          children: [
            {
              id: 100021,
              name: 'Futbol',
              link: {
                url: 'http://bbnx.int.bitban.com/deportes/futbol',
                type: 'manual',
              },
              children: [],
            },
            {
              id: 100022,
              name: 'Baloncesto',
              link: {
                url: 'http://bbnx.int.bitban.com/deportes/baloncesto',
                type: 'manual',
              },
              children: [],
            },
          ],
        },
        {
          id: 10003,
          name: 'Ayuda',
          link: {
            url: 'http://bbnx.int.bitban.com/help',
            type: 'manual',
          },
        },
      ],
      permissions: {
        boards: [],
        content: [
          {
            id: 12231132,
            action: 'edit',
            type: 'Todos',
            taxonomy: 'Deportes',
            origin: 'Individual',
          },
          {
            action: 'edit',
            type: 'Noticia',
            taxonomy: 'Deportes',
            origin: 'Individual',
          },
          {
            action: 'edit',
            type: 'Video',
            taxonomy: 'Todos',
            origin: 'Individual',
          },
        ],
        taxonomies: [],
        tools: [],
        config: [],
        admin: [],
        sites: [],
      },
    };
  },
  methods: {
    onInput(field, value) {
      this[field].value = value;
    },
  },
  mounted() {
    this.finishLoading();
  },
};

</script>
